// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5901febb","531":"fc083e53","885":"d0886a5f"}[chunkId] + ".chunk.js";
};